import { Injectable } from '@angular/core';
import { Server } from '#enums';

@Injectable({
  providedIn: 'root',
})
export class MOCChecklistHelper {
  lockedMOCChecklistTypes = [
    Server.MOCChecklistType.FRA as string,
    Server.MOCChecklistType.FR as string,
    Server.MOCChecklistType.PSI as string,
    Server.MOCChecklistType.RS as string,
    Server.MOCChecklistType.PSSR as string,
    Server.MOCChecklistType.ROOTMOC as string,
  ];

  public isMOCChecklistLocked(itemCode: string): boolean {
    const isMocChecklistLocked =
      this.lockedMOCChecklistTypes.includes(itemCode) || itemCode.startsWith(Server.MOCChecklistType.IS);
    return isMocChecklistLocked;
  }
}
